import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IMotorista } from '../models/motorista.model';

type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]> | any[] | string | number | boolean;
};

export const mockActivatedRoute = (value: DeepPartial<ActivatedRoute>) => ({
  provide: ActivatedRoute,
  useValue: { ...value }
});

@Injectable()
export class MotoristaService extends EntityService<IMotorista> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'motorista'
      }
    );
  }
}
